import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { PICFLOW_CONFIG } from '../../picflow-config';
import { PublicTenantService } from '../../services/public-tenant.service';
import { RedirectService } from '../../services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class TenantProfileMaintenanceGuard {
  private publicTenantService = inject(PublicTenantService);
  private redirectService = inject(RedirectService);
  private config = inject(PICFLOW_CONFIG);

  async canActivate(): Promise<UrlTree | boolean> {
    try {
      await this.publicTenantService.getTenant('maintenance-test'); // name doesn't matter, just looking at the error code
      return this.redirectService.redirectTo(['/']);
    } catch (error) {
      if (!(error instanceof HttpErrorResponse)) throw error;
      if (error.status === 503) return true;
      return this.redirectService.redirectTo(['/']);
    }
  }
}
